import { DBDef_FindingView } from '@app/advisor-ui-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_FindingView } from '../../_entity/finding-view/ModuleFE_FindingView.js';
import { Manager_FindingView } from '../../ui/_managers/Manager_FindingView/Manager_FindingView.js';
import { ConfigDialogKeys_AdvisorUI, ConfigDialogs_AdvisorUI_Dialogs, ConfigDialogs_AdvisorUI_Labels } from '../../ui/config-dialogs/index.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_FindingView,
    dbDef: DBDef_FindingView,
    tag: ['Fv', 'Finding View'],
    modulesToAwait: [ModuleFE_FindingView],
    ManagerComponent: Manager_FindingView,
    extraMenuSections: () => [{
            actions: ConfigDialogKeys_AdvisorUI.map(key => ({
                label: ConfigDialogs_AdvisorUI_Labels[key],
                action: () => ConfigDialogs_AdvisorUI_Dialogs[key].show(),
            })),
        }],
    resultSubtitle: (findingView) => findingView?.type,
});
export const WorkHubItem_FindingView = WorkHubItem;
export const UtilObject_FindingView = UtilObject;
export const SearchItem_FindingView = SearchItem;
//# sourceMappingURL=finding-view.js.map